import React from 'react';
import { Stack, Tooltip, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { useDispatch } from 'react-redux';
import { openDialog } from '@/features/dialog/dialogSlice';
import { SCOPES } from '@/features/config/scopes';
import { BrokerGroupChipsCell } from '../../shared/chips/BrokerGroupChipsCell';
import { useFormFieldConfigScope } from '../useFormFieldConfigScope';
import { SHARE_FORM_FIELD_CONFIGS_DIALOG } from '../ShareFormFieldConfigsDialog';

/**
 * The broker groups a config row is shared with, as chips (editing the row changes theirs
 * too). On a row the page's broker group owns (not one shared into it), clicking opens the
 * share dialog with those groups ticked, to change who it's shared with, once there are no
 * unsaved changes.
 */
export const FormFieldConfigSharedWithCell = ({ config }) => {
	const dispatch = useDispatch();
	const { scope } = useFormFieldConfigScope();
	const { dirty } = useFormikContext();

	const sharedWith = config.sharedWith ?? [];
	const isOwnOriginal =
		config.scope === SCOPES.BROKER_GROUP &&
		config.scopeId === scope.scopeId &&
		!config.sharedFrom;

	// One line that expands, like the other broker group cells; its arrow doesn't open the dialog
	const chips = sharedWith.length ? (
		<BrokerGroupChipsCell brokerGroupIds={sharedWith} />
	) : (
		isOwnOriginal && (
			<Typography variant='body2' color='text.disabled'>
				Not shared
			</Typography>
		)
	);
	if (!isOwnOriginal) return chips;

	const openShareDialog = () =>
		dispatch(
			openDialog({
				dialogName: SHARE_FORM_FIELD_CONFIGS_DIALOG,
				data: { docIds: [config.id], sharedWith, skipped: 0 },
			}),
		);

	return (
		<Tooltip title={dirty ? 'Save or cancel your changes first' : ''}>
			<Stack
				onClick={(event) => {
					event.stopPropagation();
					if (!dirty) openShareDialog();
				}}
				sx={{
					cursor: dirty ? 'default' : 'pointer',
					width: '100%',
					height: '100%',
					justifyContent: 'center',
				}}
			>
				{chips}
			</Stack>
		</Tooltip>
	);
};

FormFieldConfigSharedWithCell.displayName = 'FormFieldConfigSharedWithCell';
